import DOMPurify from "dompurify";
import { KB_STATUS } from "./knowledgeBase.constants";

const VIDEO_HOSTS = ["www.youtube.com", "www.youtube-nocookie.com", "player.vimeo.com"];

// Turns a YouTube / Vimeo page URL into an embeddable URL, or null if unsupported.
export const toEmbedUrl = (input = "") => {
  try {
    const url = new URL(input.trim());
    const host = url.hostname.replace(/^www\./, "");
    if (host === "youtu.be") return `https://www.youtube.com/embed/${url.pathname.slice(1)}`;
    if (host === "youtube.com" || host === "m.youtube.com") {
      if (url.pathname === "/watch" && url.searchParams.get("v")) {
        return `https://www.youtube.com/embed/${url.searchParams.get("v")}`;
      }
      if (url.pathname.startsWith("/embed/")) return `https://www.youtube.com${url.pathname}`;
    }
    if (host === "vimeo.com" && /^\/\d+/.test(url.pathname)) {
      return `https://player.vimeo.com/video/${url.pathname.split("/")[1]}`;
    }
    if (host === "player.vimeo.com") return url.href;
  } catch (e) {
    /* invalid URL */
  }
  return null;
};

// Dedicated DOMPurify instance so the hook below never affects other pages.
const purify = DOMPurify(window);
purify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName !== "iframe") return;
  let allowed = false;
  try {
    const url = new URL(node.getAttribute("src") || "");
    allowed = url.protocol === "https:" && VIDEO_HOSTS.includes(url.hostname);
  } catch (e) {
    /* invalid URL */
  }
  if (!allowed) node.parentNode?.removeChild(node);
});

export const sanitizeArticleHtml = (html) =>
  purify.sanitize(html || "", {
    USE_PROFILES: { html: true },
    ADD_TAGS: ["video", "source", "iframe"],
    ADD_ATTR: ["controls", "allowfullscreen", "frameborder", "allow"],
    FORBID_TAGS: ["script", "object", "embed", "style"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "style"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|blob):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  });

export const isContentEmpty = (html = "") => {
  if (/<(img|video|iframe)\b/i.test(html)) return false;
  const node = document.createElement("div");
  node.innerHTML = html;
  return !(node.textContent || "").trim();
};

export const validateArticle = (form) => {
  const errors = {};
  if (!form.title.trim()) errors.title = "Title is required";
  if (isContentEmpty(form.content)) errors.content = "English content is required";
  if (isContentEmpty(form.content_nl)) errors.content_nl = "Dutch content is required";
  if (!form.category) errors.category = "Category is required";
  return errors;
};

export const buildArticlePayload = (form) => ({
  title: form.title.trim(),
  content: sanitizeArticleHtml(form.content),
  content_nl: sanitizeArticleHtml(form.content_nl),
  category: form.category,
  status: form.publish ? KB_STATUS.PUBLISHED : KB_STATUS.DRAFT,
});
